var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "35C47FCB-31A0-49E6-8EA4-84BA66387B5D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Client-|-Upload-Chart",
    transform: "translate(-1271.000000, -594.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1271.000000, 594.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6DE584",
    cx: 19,
    cy: 19,
    r: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7024788,10.2627646 C28.4237843,9.94421651 27.9260958,9.90450509 27.6075442,10.2030535 C26.37333,11.2781163 25.2386876,12.4127587 24.1039031,13.5872511 C22.9891324,14.7618858 21.8941978,15.9562499 20.8391134,17.1904641 C19.2863476,19.0417676 17.7933035,20.9728424 16.3997957,22.9635678 L11.3433532,17.5288874 C11.1045088,17.2700505 10.7063921,17.1904819 10.3878405,17.3894691 C10.0095671,17.608456 9.89015917,18.0862941 10.1091461,18.4643897 C10.1091461,18.4643897 14.9267016,26.7657147 15.1257741,27.1240453 C15.3249035,27.4624508 15.7628773,28 16.6586682,28 C17.534623,28 18.0122904,27.4824469 18.2911342,26.9449155 C18.5896861,26.3875124 21.2573506,21.4505134 22.9892461,18.8426631 C23.845187,17.5287488 24.7808279,16.2546845 25.7165044,15.0005631 C26.672017,13.7463705 27.6673797,12.5121563 28.6827208,11.3575356 L28.7025779,11.3376784 C28.9612763,10.9992729 28.9612763,10.5612955 28.7024391,10.2626156 L28.7024788,10.2627646 Z",
    id: "Path-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick-icon.b435260fa7f8235f9dbc74775a60f14d.svg";
export { ForwardRef as ReactComponent };